import { useState, useEffect } from 'react'

export function useCountdown(initialSeconds: number) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    const endTimeStr = localStorage.getItem('offerEndTime')
    let endTime: number

    if (endTimeStr) {
      endTime = parseInt(endTimeStr, 10)
      if (endTime < Date.now()) {
        // Restart if expired
        endTime = Date.now() + initialSeconds * 1000
        localStorage.setItem('offerEndTime', endTime.toString())
      }
    } else {
      endTime = Date.now() + initialSeconds * 1000
      localStorage.setItem('offerEndTime', endTime.toString())
    }

    const interval = setInterval(() => {
      const newTimeLeft = Math.max(0, Math.floor((endTime - Date.now()) / 1000))
      setTimeLeft(newTimeLeft)

      if (newTimeLeft === 0) {
        // Restart timer automatically for better conversion
        const nextEndTime = Date.now() + initialSeconds * 1000
        localStorage.setItem('offerEndTime', nextEndTime.toString())
        setTimeLeft(initialSeconds)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [initialSeconds])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return { minutes, seconds, timeLeft }
}
